import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import axios from "axios";
import { axiosAPI } from "../AxiosComponents/Axios";
import { StaffLayoutProvider } from "../Context/CandidateLayoutContext";
import { errorNotify, successNotify } from "../ToastComponent/ToastNotification";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  Avatar,
  Typography,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  CssBaseline,
  Box,
  useMediaQuery,
  MenuItem,
  Menu,
  FormControlLabel,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import {
  Menu as MenuIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";

import { ExpandLess, ExpandMore } from "@mui/icons-material";

import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import GroupIcon from "@mui/icons-material/Group";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import ChangePasswordModal from "../Modals/ChangePasswordModal";
import LockResetIcon from "@mui/icons-material/LockReset";
import CircleIcon from "@mui/icons-material/Circle";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import CommonButton from "../InputComponents/CommonButton";
import SelectInput from "../InputComponents/SelectInput";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import RuleFolderIcon from "@mui/icons-material/RuleFolder";
import WorkIcon from "@mui/icons-material/Work";
import TableChartIcon from "@mui/icons-material/TableChart";

export default function NavbarSidebarLayoutAdmin({
  viewNav = true,
  children,
  isAdmin,
  setIsAdmin,
  privilegeData,
  setprivilegeData,
}) {
  // bg "#006CB8",
  // hover "#055C9D"

  // new bg #2D768A
  // new hover #1F8DAC

  let backgroundcolor = `#006CB8`;
  let backgroundHoverColor = `#055C9D`;

  const isMobile = useMediaQuery("(max-width: 1220px)");
  const Navigate = useNavigate();
  const location = useLocation();

  const [openModal, setOpenModal] = useState(false);

  const [autoDelete, setAutoDelete] = useState(true);

  const [FontFamilyValue, setFontFamily] = useState("Geist, sans-serif");
  const [fontWeightValue, setfontWeightValue] = useState("400");
  const [isCollapsed, setIsCollapsed] = useState(isMobile ? false : true);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const [openSubMenu2, setOpenSubMenu2] = useState(null);

  const matchPath = (basePath) =>
    new RegExp(`^${basePath}(/|$)`).test(location.pathname);

  useEffect(() => {
    const activeMenu = menuItems.find((item) =>
      item.subItems?.some((subItem) => matchPath(subItem.path))
    );

    if (activeMenu) {
      setOpenSubMenu2(activeMenu.label);
    }
  }, [location.pathname]);

  const handleSubMenuToggle2 = (label) => {
    setOpenSubMenu2((prev) => (prev === label ? null : label));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [staffData, setStaffData] = useState({});
  const [userType, setUserType] = useState("");

  const logoutfn = () => {
    axiosAPI
      .post(`candidate/logout`)
      .then((res) => {
        if (res?.data?.success) {
          successNotify(res?.data?.message);
          localStorage.removeItem("SWA_userRole");
          localStorage.removeItem("SWA_token");
          localStorage.removeItem("SWA_UserId");
          localStorage.removeItem("SWA_IsAdmin");

          sessionStorage.removeItem("SWA_userRole");
          sessionStorage.removeItem("SWA_token");
          sessionStorage.removeItem("SWA_UserId");
          sessionStorage.removeItem("SWA_IsAdmin");

          Navigate("/Login/Admin");
        } else {
          successNotify("Logged out Successfully!");
          localStorage.removeItem("SWA_userRole");
          localStorage.removeItem("SWA_token");
          localStorage.removeItem("SWA_UserId");
          localStorage.removeItem("SWA_IsAdmin");

          sessionStorage.removeItem("SWA_userRole");
          sessionStorage.removeItem("SWA_token");
          sessionStorage.removeItem("SWA_UserId");
          sessionStorage.removeItem("SWA_IsAdmin");
          Navigate("/Login/Admin");
        }
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
  };

  const getData = async () => {
    try {
      const id =
        localStorage?.getItem("SWA_UserId") ||
        sessionStorage?.getItem("SWA_UserId");
      const res = await axiosAPI.get(`/Employee/listbyid/${id}`);
      setStaffData(res?.data?.data);
      setUserType(res?.data?.data?.ED_UserType);
     
      
      if (res?.data?.data?.ED_Photo) {
        setPreviewUrl2(
          res?.data?.data?.ED_Photo
            ? `${process.env.REACT_APP_BASE_URL}/${res?.data?.data?.ED_Photo}`
            : null
        );
      }

      setIsAdmin(
        localStorage?.getItem("SWA_IsAdmin") == 1 ||
          sessionStorage?.getItem("SWA_IsAdmin") == 1
          ? true
          : false
      );
    } catch (err) {
      console.error(err);
    }

    getImageData();
  };

  const [previewUrl, setPreviewUrl] = useState("");
  const [previewUrl2, setPreviewUrl2] = useState("");

  const getImageData = async () => {
    await axiosAPI
      ?.get(`/settings/view`)
      .then((res) => {
        setPreviewUrl(
          res?.data?.data?.SS_Companylogo
            ? `${process.env.REACT_APP_BASE_URL}/${res?.data?.data?.SS_Companylogo}`
            : null
        );
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
  };

  const getprivilegesList = async () => {
    try {
      const res = await axiosAPI.get(`privilege/list/${userType}`);
      setprivilegeData(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  function hasSettingsView(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("settings");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (userType) {
      getprivilegesList();
    }
  }, [userType]);

  const [menuItems, setMenuItems] = useState([]);

  function hasClientAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("client");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasClientEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("client");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasClientViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("client");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasStaffAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasStaffEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasStaffViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasCandAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasCandEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasCandViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasJobAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("job");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasJobEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("job");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned == true
      );
    });
  }

  function hasJobViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("job");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned == true
      );
    });
  }

  function hasRecProcAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasRecProcEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned == true
      );
    });
  }

  function hasRecProcViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned == true
      );
    });
  }

  function hasRecProcMapAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure mapping");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasDocCheckAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document checklist");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasDocCheckEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document checklist");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasRolesAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("roles");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasRolesEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("roles");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned == true
      );
    });
  }

  function hasProfAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("profession");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasProfEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("profession");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasQualAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("qualification");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasQualEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("qualification");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasDesigAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("designation");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasDesigEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("designation");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hascomptypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("company type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hascomptypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("company type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasemptypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("employment type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasemptypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("employment type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasemptypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("employment type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasemptypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("employment type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasdoctypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasdoctypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasreccounAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment country");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasreccounEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment country");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasbranchAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("branch");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasbranchEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("branch");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasdepartAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("department");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasdepartEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("department");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasaddreqAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("additional requirement");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasaddreqEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("additional requirement");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hassalpayAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("salary pay");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hassalpayEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("salary pay");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasyoeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("year of experience");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasyoeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("year of experience");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasAuditLog(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("audit log");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasReport(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("reports");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasSettingsView(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("settings");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  useEffect(() => {
    const items = [
      {
        label: "Home",
        icon: (
          <HomeIcon
            sx={{ fontSize: "27px", position: "relative", right: "4px" }}
          />
        ),
        path: "/",
      },
      (hasClientAddprivilege(privilegeData) ||
        hasClientEditprivilege(privilegeData) ||
        hasClientViewprivilege(privilegeData)) && {
        label: "Clients",
        icon: (
          <GroupIcon
            sx={{ fontSize: "27px", position: "relative", right: "3px" }}
          />
        ),
        path: "/Clients",
      },
      (hasStaffAddprivilege(privilegeData) ||
        hasStaffEditprivilege(privilegeData) ||
        hasStaffViewprivilege(privilegeData)) && {
        label: "Staffs",
        icon: (
          <PersonIcon
            sx={{ fontSize: "27px", position: "relative", right: "5px" }}
          />
        ),
        path: "/Staffs",
      },
      (hasCandAddprivilege(privilegeData) ||
        hasCandEditprivilege(privilegeData) ||
        hasCandViewprivilege(privilegeData)) && {
        label: "Candidates",
        icon: (
          <AccountBoxOutlinedIcon
            sx={{ fontSize: "27px", position: "relative", right: "5px" }}
          />
        ),
        path: "/Candidates",
      },
      (hasJobAddprivilege(privilegeData) ||
        (hasJobEditprivilege(privilegeData) &&
          hasJobViewprivilege(privilegeData))) && {
        label: "Jobs",
        icon: (
          <WorkIcon
            sx={{ fontSize: "27px", position: "relative", right: "5px" }}
          />
        ),
        path: "/Jobs",
      },
      (() => {
        const subItems = [
          (hasRecProcAddprivilege(privilegeData) ||
            hasRecProcEditprivilege(privilegeData) ||
            hasRecProcViewprivilege(privilegeData)) && {
            label: "Recruitment Procedure",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/RecruitmentProcedure",
          },
          hasRecProcMapAddprivilege(privilegeData) && {
            label: "Recruitment Procedure Mapping",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/RecruitmentMappingProcedure",
          },
          (hasDocCheckAddprivilege(privilegeData) ||
            hasDocCheckEditprivilege(privilegeData)) && {
            label: "Document Checklist",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/DocumentProcedure",
          },
        ].filter(Boolean);

        return subItems.length > 0
          ? {
              label: "Process Flow",
              icon: (
                <AssessmentIcon
                  sx={{ fontSize: "27px", position: "relative", right: "5px" }}
                />
              ),
              subItems,
            }
          : false;
      })(),
      (() => {
        const subItems = [
          (hasProfAddprivilege(privilegeData) ||
            hasProfEditprivilege(privilegeData)) && {
            label: "Profession",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/ProfessionLookup",
          },
          (hasQualAddprivilege(privilegeData) ||
            hasQualEditprivilege(privilegeData)) && {
            label: "Qualification",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/QualificationLookup",
          },
          (hasDesigAddprivilege(privilegeData) ||
            hasDesigEditprivilege(privilegeData)) && {
            label: "Designation",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/DesignationLookup",
          },
          (hascomptypeAddprivilege(privilegeData) ||
            hascomptypeEditprivilege(privilegeData)) && {
            label: "Company Type",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/CompanyTypeLookup",
          },
          (hasemptypeAddprivilege(privilegeData) ||
            hasemptypeEditprivilege(privilegeData)) && {
            label: "Employment Type",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/EmploymentTypeLookup",
          },
          (hasdoctypeAddprivilege(privilegeData) ||
            hasdoctypeEditprivilege(privilegeData)) && {
            label: "Document Type",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/DocumentLookup",
          },
          (hasreccounAddprivilege(privilegeData) ||
            hasreccounEditprivilege(privilegeData)) && {
            label: "Recruitment Country",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/RecruitmentCountryLookup",
          },
          (hasbranchAddprivilege(privilegeData) ||
            hasbranchEditprivilege(privilegeData)) && {
            label: "Branch",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/BranchLookup",
          },
          (hasdepartAddprivilege(privilegeData) ||
            hasdepartEditprivilege(privilegeData)) && {
            label: "Department",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/DepartmentLookup",
          },
          (hasaddreqAddprivilege(privilegeData) ||
            hasaddreqEditprivilege(privilegeData)) && {
            label: "Additional Requirements",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/AdditionalRequirementsLookup",
          },
          (hassalpayAddprivilege(privilegeData) ||
            hassalpayEditprivilege(privilegeData)) && {
            label: "Salary Pay",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/SalaryPayLookup",
          },
          (hasyoeAddprivilege(privilegeData) ||
            hasyoeEditprivilege(privilegeData)) && {
            label: "Years Of Experience",
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
            path: "/YearsOfExperienceLookup",
          },
        ].filter(Boolean);

        return subItems.length > 0
          ? {
              label: "Lookups",
              icon: (
                <ContentPasteSearchIcon
                  sx={{ fontSize: "27px", position: "relative", right: "5px" }}
                />
              ),
              subItems,
            }
          : false;
      })(),
      (hasRolesAddprivilege(privilegeData) ||
        hasRolesEditprivilege(privilegeData)) && {
        label: "Roles & privileges",
        icon: (
          <RuleFolderIcon
            sx={{ fontSize: "27px", position: "relative", right: "4px" }}
          />
        ),
        subItems: [
          (hasRolesAddprivilege(privilegeData) ||
            hasRolesEditprivilege(privilegeData)) && {
            label: "Roles",
            path: "/Roles",
          },

          isAdmin && { label: "Privileges", path: "/privileges" },
          isAdmin && { label: "Client privileges", path: "/Clientprivileges" },
        ]
          .filter(Boolean) // 👈 removes false values
          .map((item) => ({
            ...item,
            icon: <CircleIcon sx={{ fontSize: "10px" }} />,
          })),
      },

      hasReport(privilegeData) && {
        label: "Reports",
        icon: (
          <TableChartIcon
            sx={{ fontSize: "27px", position: "relative", right: "5px" }}
          />
        ),
        path: "/Reports",
      },

      hasAuditLog(privilegeData) && {
        label: "Audit Log",
        icon: (
          <BrowserUpdatedIcon
            sx={{ fontSize: "27px", position: "relative", right: "4px" }}
          />
        ),
        path: "/AuditLog",
      },

      hasSettingsView(privilegeData) && {
        label: "Settings",
        icon: (
          <SettingsIcon
            sx={{ fontSize: "27px", position: "relative", right: "4px" }}
          />
        ),
        path: "/Settings",
        // subItems: [
        //   { label: "System", path: "/SystemSettings" },
        //   { label: "General", path: "/GeneralSettings" },
        // ].map((item) => ({
        //   ...item,
        //   icon: <CircleIcon sx={{ fontSize: "10px" }} />,
        // })),
      },
    ].filter(Boolean); // Removes false entries if isAdmin is true

    setMenuItems(items);
  }, [isAdmin, privilegeData]); // Optional dependency

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        margin: "0px",
      }}
    >
      <ChangePasswordModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        userType="Employee"
      />
      <CssBaseline />

      {/* Sidebar */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isCollapsed || !isMobile}
        onClose={() => setIsCollapsed(false)}
        sx={{
          display: viewNav ? "block" : "none",
          width: isMobile ? 240 : isCollapsed ? 80 : 260,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            transition: "width 0.3s ease-in-out",
            width: isMobile ? 240 : isCollapsed ? 80 : 260,
            background: backgroundcolor,
            color: "white",
            borderRadius: "0px 50px 0px 0px",
            margin: isMobile ? "0px" : "0px 10px 0px 0px",
            border: `2px solid ${backgroundcolor}`,
            overflowX: "hidden",
          },
        }}
      >
        <List
          sx={{
            background: backgroundcolor,
            minHeight: "76px",
          }}
        >
          {!isMobile && (
            <IconButton
              edge="start"
              sx={{
                position: "relative",
                left: isCollapsed ? "16px" : "17px",
                transition: "all 0.1s ease-in-out",
              }}
            >
              <MenuIcon
                sx={{ color: "white", fontSize: "40px" }}
                onClick={() => setIsCollapsed(!isCollapsed)}
              />
              <Typography
                sx={{
                  fontFamily: FontFamilyValue,
                  color: "white",
                  fontSize: "22px",
                  fontWeight: fontWeightValue,
                  margin: "0px 12px",
                }}
                onClick={() => {
                  Navigate(`/`);
                }}
              >
                {/* {staffData?.ED_UserName?staffData?.ED_UserName:`Admin`} */}
              </Typography>
            </IconButton>
          )}
        </List>

        <List sx={{ padding: "0px" }}>
          {menuItems.map((item, index) => {
            const isSubMenuOpen = openSubMenu2 === item.label;
            const hasSubItems = !!item.subItems;
            const matchPath = (base) =>
              new RegExp(`^${base}(/|$)`).test(location.pathname);

            const isItemActive = !hasSubItems && matchPath(item.path);

            const isSubItemActive = item.subItems?.some((sub) =>
              matchPath(sub.path)
            );

            const isActiveCollapsed =
              isCollapsed && (isItemActive || isSubItemActive);
            const isActiveExpanded = !isCollapsed && !isMobile && isItemActive;

            const isActive = isActiveCollapsed || isActiveExpanded;

            const parentStyles = {
              color: isActive ? backgroundcolor : "white",
              background: isActive ? "white" : backgroundcolor,
              fontweight: isActive ? "700" : "600",
              cursor: "pointer",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: isActive ? "white" : backgroundHoverColor,
                color: isActive ? backgroundcolor : "white",
                transition: "all 0.3s ease-in-out",
              },
            };

            return (
              <div key={index}>
                <ListItem
                  button
                  onClick={() => {
                    // if sidebar is closed, clicking the icon with submenu wont toggle submenu. Just the whole sidebar will be opened or closed
                    if (!isCollapsed || isMobile) {
                      handleSubMenuToggle2(item.label);
                    }

                    // if sidebar is closed,
                    // and viewport is not for mobile,
                    // and if item has submenu, sidebar will open
                    if (isCollapsed && !isMobile && hasSubItems) {
                      setIsCollapsed(false);
                    }

                    // if viewport is for mobile, and if you click item without submenu, the sidebar will close.
                    // if sidebar item has a submenu, the main item will not cause sidebar to close.
                    else if (isMobile && !hasSubItems) {
                      setIsCollapsed(false);
                    }
                  }}
                  component={!hasSubItems ? Link : "div"}
                  to={!hasSubItems ? item.path : undefined}
                  sx={{
                    ...parentStyles,
                    minHeight: "48px",
                    justifyContent:
                      isCollapsed && !isMobile ? "center" : "center",
                    px: 2,
                    // border:'2px solid red'
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: isActive ? backgroundcolor : "white",
                      minWidth: 0,
                      mr: 2,
                      justifyContent: "center",
                      position: "relative",
                      left: isMobile ? "0px" : isCollapsed ? "8px" : "0px",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  <ListItemText
                    primary={item.label}
                    sx={{ textWrap: "nowrap" }}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: FontFamilyValue,
                        opacity: !isCollapsed || isMobile ? 1 : 0,
                        display: !isCollapsed || isMobile ? "block" : "none",
                        fontSize: "15px",
                        fontWeight: "500",
                      },
                    }}
                  />

                  {hasSubItems &&
                    (!isCollapsed || isMobile) &&
                    (isSubMenuOpen ? <ExpandLess /> : <ExpandMore />)}
                </ListItem>

                {/* Submenu */}
                {hasSubItems && (!isCollapsed || isMobile) ? (
                  <Collapse in={isSubMenuOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.subItems.map((subItem, subIndex) => {
                        const isSubActive = location.pathname.startsWith(
                          subItem.path
                        ); // or use regex version

                        return (
                          <ListItem
                            key={subIndex}
                            button
                            component={Link}
                            to={subItem.path}
                            onClick={() => {
                              if (isMobile) {
                                // if mobile viewport, clicking the submenu item
                                // will close the sidebar
                                setIsCollapsed(false);
                              }
                            }}
                            sx={{
                              pl: 4,
                              minHeight: "48px",
                              color: isSubActive ? backgroundcolor : "white",
                              background: isSubActive
                                ? "white"
                                : backgroundcolor,
                              transition: "all 0.3s ease-in-out",
                              "&:hover": {
                                backgroundColor: isSubActive
                                  ? "white"
                                  : backgroundHoverColor,
                                color: isSubActive ? backgroundcolor : "white",
                                transition: "all 0.3s ease-in-out",
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                color: isSubActive ? backgroundcolor : "white",
                                position: "relative",
                                left: "30px",
                              }}
                            >
                              {subItem.icon}
                            </ListItemIcon>

                            <ListItemText
                              primary={subItem.label}
                              primaryTypographyProps={{
                                sx: {
                                  fontFamily: FontFamilyValue,
                                  fontSize: "14px",
                                  fontWeight: "400",
                                },
                              }}
                            />
                          </ListItem>
                        );
                      })}
                    </List>
                  </Collapse>
                ) : null}
              </div>
            );
          })}
        </List>
      </Drawer>

      {/* Main Content Area */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100vh",
        }}
      >
        {/* Navbar */}
        <AppBar
          position="static"
          sx={{
            minHeight: "80px", // Ensures a minimum height of 100px
            background: "white",
            color: "black",
            px: 2,
            display: viewNav ? "flex" : "none",
            justifyContent: "center", // Centers the content vertically
            boxShadow: "none",
            borderBottom: "2px solid #E6F1F8",
          }}
        >
          <div
            style={{
              height: "10px",
              borderTop: `10px solid ${backgroundcolor}`,
              position: "fixed",
              width: "100vw",
              left: "0px",
              top: "0px",
            }}
          ></div>
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "100%",
            }}
          >
            {/* Left Section */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {isMobile && (
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => setIsCollapsed(!isCollapsed)}
                >
                  <MenuIcon sx={{ color: "black", fontSize: "40px" }} />
                </IconButton>
              )}
            </Box>

            {/* Right Section */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 1,
                mr: 3,
              }}
            >
              {/* Notifications Icon with Badge */}
              {/* <IconButton color="inherit">
                <Badge badgeContent={notificationCount} color="error">
                  <NotificationsNoneIcon
                    sx={{ color: backgroundcolor, fontSize: "40px" }}
                    onClick={() => {
                      Navigate(`/Notifications`);
                    }}
                  />
                </Badge>
              </IconButton> */}

              {/* Profile Section */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                }}
              >
                <Avatar
                  src={previewUrl2?previewUrl2:previewUrl}
                  sx={{ width: 50, height: 50, border:'1px solid lightgrey'}}
                  onClick={() => {
                    if (!isAdmin) {
                      Navigate(`/Profile`);
                    }
                  }}
                >
                  {staffData?.ED_Name
                    ? staffData?.ED_Name[0]?.toUpperCase()
                    : ""}
                </Avatar>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: FontFamilyValue,
                      color: "black",
                      fontSize: "20px",
                      position: "relative",
                      top: "8px",
                    }}
                  >
                    {isAdmin ? "" : staffData?.ED_Name}
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: FontFamilyValue,
                      color: "black",
                      fontSize: isAdmin ? "20px" : "14px",
                      position: "relative",
                      bottom: isAdmin ? "0px" : "5px",
                    }}
                  >
                    {staffData?.ED_Designation_Name
                      ? staffData?.ED_Designation_Name
                      : `Admin`}

                    <IconButton onClick={handleClick}>
                      <ExpandMoreIcon sx={{ color: "black" }} />
                    </IconButton>
                  </Typography>
                </Box>

                {/* Dropdown Menu */}
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Adjusts initial position
                  transformOrigin={{ vertical: "top", horizontal: "right" }} // Controls where it expands from
                  sx={{
                    "& .MuiPaper-root": {
                      width: "200px", // Adjust width
                      marginTop: "25px", // Moves it further down
                      borderRadius: "8px", // Optional: Rounded corners,
                    },
                  }}
                >
                  {!isAdmin && (
                    <MenuItem
                      onClick={() => {
                        Navigate(`/Profile`);
                        handleClose();
                      }}
                    >
                      <ListItemIcon>
                        <PersonIcon />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          sx: { fontFamily: FontFamilyValue },
                        }}
                        primary="Profile"
                      />
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => {
                      setOpenModal(true);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <LockResetIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Change Password"
                    />
                  </MenuItem>
                  {hasSettingsView(privilegeData) && (
                    <MenuItem
                      onClick={() => {
                        // Navigate(`/SystemSettings`);
                        handleClose();
                      }}
                    >
                      <ListItemIcon>
                        <SettingsIcon />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          sx: { fontFamily: FontFamilyValue },
                        }}
                        onClick={() => {
                          Navigate("/Settings");
                        }}
                        primary="Settings"
                      />
                    </MenuItem>
                  )}

                  <MenuItem onClick={logoutfn}>
                    <ListItemIcon>
                      <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Logout"
                    />
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Content View */}
        <StaffLayoutProvider
          value={{
            privilegeData,
            triggerSomethingFromLayout: getprivilegesList,
            triggerProfileAPI: getData,
            isCollapsed,
          }}
        >
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              backgroundColor: "white",
              p: 1,
              maxWidth: `calc(100vw - ${
                isMobile ? 0 : isCollapsed ? 80 : 260
              }px)`,
            }}
          >
            {children}
          </Box>
        </StaffLayoutProvider>
      </Box>

      <Dialog open={open2} onClose={handleClose2} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            color: "#0977BC",
            mt: 3,
            mb: 2,
            fontFamily: "Geist, sans-serif",
          }}
        >
          Personalised Settings
        </DialogTitle>

        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <SelectInput
              placeholder="Choose Notification Medium"
              name="notification_medium"
              value={``}
              // onChange={handleInputChange}
              // error={!!errors.notification_medium}
              options={[
                { value: "email", label: "Email" },
                { value: "sms", label: "SMS" },
                { value: "push", label: "Push Notification" },
              ]}
            />
          </Box>

          <FormControlLabel
            control={
              <Switch
                checked={autoDelete}
                onChange={(e) => setAutoDelete(e.target.checked)}
              />
            }
            label="Auto delete notifications"
            sx={{ mb: 2 }}
          />

          {autoDelete && (
            <SelectInput
              label="Delete Frequency"
              placeholder="Choose Delete Frequency"
              value={``}
              // onChange={handleInputChange}
              // error={!!errors.notification_medium}
              options={[
                { value: "After 1 day", label: "1" },
                { value: "After 7 days", label: "7" },
                { value: "After 30 days", label: "30" },
              ]}
            />
          )}
        </DialogContent>

        <DialogActions sx={{ mt: 3, mb: 3, mr: 3 }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <CommonButton
              variant="outlined"
              customColor="#B0BEC5"
              onClick={handleClose2}
            >
              Cancel
            </CommonButton>
            <CommonButton
              variant="contained"
              customColor="#007BFF"
              onClick={handleClose2}
            >
              Save
            </CommonButton>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
